export const profileEdit = () => {
    function editLink(event, action) {
        const linkReference = event.target.getAttribute('data-linkreference');
        const propertyName = linkReference.split('_')[0].toLowerCase();
        const targetName = `${propertyName}-target`;
        const linkListTarget = document.querySelector(`#${targetName}`);

        let url = '';
        let dataInput;

        if (action === 'delete') {
            url = '/LumcProfilePageForm/DeleteLink';
            dataInput = $.param({ linkId: linkReference });
        }

        if (action === 'add') {
            url = '/LumcProfilePageForm/AddLink';

            const urlFieldName = `#${linkReference}__Url`;
            const textFieldName = `#${linkReference}__Text`;

            const urlInput = $(urlFieldName).val();
            const textInput = $(textFieldName).val();

            dataInput = $.param({
                linkId: linkReference,
                url: urlInput,
                text: textInput,
            });
        }

        $.blockUI({
            message: $('#loader-message'),
        });

        $.ajax({
            type: 'POST',
            url,
            data: dataInput,
            success(data) {
                linkListTarget.innerHTML = data;
                $.unblockUI();
            },
        });

        event.preventDefault();

        return false;
    }

    function editStringItem(event, action) {
        const stringItemReference = event.target.getAttribute(
            'data-stringitemreference'
        );
        const stringFieldName = `#${stringItemReference}`;
        const propertyName = stringItemReference.split('_')[0].toLowerCase();
        const targetName = `${propertyName}-target`;
        const stringListTarget = document.querySelector(`#${targetName}`);
        const language = document.getElementById('Language').value;

        let url = '';
        let dataInput;

        if (action === 'delete') {
            url = '/LumcProfilePageForm/DeleteString';
            dataInput = $.param({
                stringId: stringItemReference,
                language: language,
            });
        }

        if (action === 'add') {
            url = '/LumcProfilePageForm/AddString';

            const textInput = $(stringFieldName).val();

            dataInput = $.param({
                stringId: stringItemReference,
                text: textInput,
                language: language,
            });
        }

        $.blockUI({
            message: $('#loader-message'),
        });

        $.ajax({
            type: 'POST',
            url,
            data: dataInput,
            success(data) {
                stringListTarget.innerHTML = data;
                $.unblockUI();
            },
        });

        event.preventDefault();

        return false;
    }

    const profileEditForm = document.getElementById('profile-edit-form');

    if (!profileEditForm) {
        return;
    }

    let saveButton = $('#save-profile-button-label');

    $('#update-profile-result').on('change', 'input,textarea', () => {
        saveButton = $('#save-profile-button-label');
        saveButton.removeClass('hidden');
    });

    $(document).on('click', '.delete-link', (element) => {
        editLink(element, 'delete');
    });

    $(document).on('click', '.add-link', (element) => {
        editLink(element, 'add');
    });

    $(document).on('click', '.delete-stringitem', (element) => {
        editStringItem(element, 'delete');
    });

    $(document).on('click', '.add-stringitem', (element) => {
        editStringItem(element, 'add');
    });
};
